import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef  } from '@angular/material/dialog';
import { SupplementaryEquipmentHandout } from '../model/supplementary-equipment-handout.model';
import { AppServerAPI, Identity, ResponseMessage, ResponseStatus, ServiceResponse } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-tmc-supplementary-equipment-handout',
    templateUrl: './supplementary-equipment-handout.component.html',
    styleUrls: ['./supplementary-equipment-handout.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentHandoutComponent implements OnInit {

  handout = new SupplementaryEquipmentHandout();
  isLoading = false;

  identity;

  formGroup = new FormGroup({});

  responseMessages: ResponseMessage[];

  constructor(
    public dialogRef: MatDialogRef<SupplementaryEquipmentHandoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService) {

    this.isLoading = true;
    this.identity = new Identity();
    this.identity.id = data.visitId;


  }

  ngOnInit() {
    this.appServerAPI.execute<SupplementaryEquipmentHandout>(`/client/visit/control/visit/supplementaryequipment/handout/details`, this.identity).subscribe(
      response => {
        this.handout = response;
        this.isLoading = false;
        this.setupForm();
      }, error => {
        console.error(error);
        this.isLoading = false;
      });
  }

  private setupForm() {
    this.handout.supplementaryEquipments.forEach(se => {
      const equipmentFormGroup = new FormGroup({
        selected: new FormControl(se.selected),
        identifier: new FormControl(se.selectedIdentifier, Validators.required)
      })
      this.formGroup.addControl(se.equipmentTypeId, equipmentFormGroup);
    });

    this.formGroup.valueChanges.subscribe(values => {
      this.handout.supplementaryEquipments.forEach(se => {
        se.selected = values[se.equipmentTypeId].selected;
        se.selectedIdentifier = values[se.equipmentTypeId].identifier;

        if (se.selected && se.availableIdentifiers.length > 0) {
          this.formGroup.get([se.equipmentTypeId, 'identifier'])?.enable({onlySelf: true, emitEvent: false});
        }

      });
    });
  }

  isSaveDisabled(): boolean {
    if (this.isLoading) {
      return true;
    }
    // kein check, wenn es keine SE gibt
    if (this.handout.supplementaryEquipments.length === 0) {
      return false;
    }
    // prüfung auf eingabe ungültiger werte
    let validCount = 0;
    for (const se of this.handout.supplementaryEquipments) {
      if (se.selected) {
        if (se.availableIdentifiers != null && se.availableIdentifiers.length > 0 && se.selectedIdentifier == null) {
          return true;
        } else {
          validCount += 1;
        }
      }
    }
    return validCount === 0;
  }

  cancel() {
    this.dialogRef.close({ status: 'cancelled' });
  }

  save() {

    this.responseMessages = [];

    this.isLoading = true;

    this.appServerAPI.execute<ServiceResponse>(`/client/visit/control/visit/supplementaryequipment/handout/save`, this.handout).subscribe(
      response => {
        if (response.status === ResponseStatus.SUCCESS) {
          this.dialogRef.close({ status: 'success' });
        } else {
          this.responseMessages = response.responseMessages;
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.log(error);
      });
  }

  isFormReadonly() {
    return this.isLoading;
  }

}
